import React from 'react';
const ProductList = ({ Data }) => {
  console.log(Data, "Data_list");

  return (
    <div className="card h-100 mb-0">
      <div className="card-body">
        <h6 className="dash-sub-head">Candidates List</h6>
        <div className='table-responsive mt-2 analytics-div table-overflow'>
          <table className='table table-striped'>
            <thead>
              <tr>
                <th style={{ width: '50%', minWidth: '200px' }}>Full Name</th>
                <th style={{ width: '16.66%', minWidth: '100px' }}>Email</th>
                <th style={{ width: '16.66%', minWidth: '100px' }}>Mobile</th>
                <th style={{ width: '16.66%', minWidth: '100px' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {Data && Data.length > 0 ? (
                Data.map((candidate, index) => (
                  <tr key={index}>
                    <td>{candidate.full_name}</td>
                    <td>{candidate.email_id}</td>
                    <td>{candidate.mobile_no}</td>
                    <td>
                      <div className={`status-bar status-${candidate.category_type === 'Hired' ? 'green' : 'red'}`}>
                        {candidate.category_type}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No candidates available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default ProductList;
